import { DateValueSettings } from '@tap/data-providers';
import { ValueProps } from './values.types';
import { Typography } from '@mui/material';
import { dateTimeHelper } from '@tap/utils';
import { PossibleDateType } from '@tap/utils/src/datetime/dateTimeHelper';


export const DateValue = ({ value, settings = {} }: ValueProps<PossibleDateType, DateValueSettings>) => {

    const { format = 'dd.MM.yyyy HH:mm:ss', emptyText = '-' } = settings;

    if (!value) {
        return (
            <Typography>{emptyText}</Typography>
        );
    }

    return (
        <Typography>{dateTimeHelper.format(value, format)}</Typography>
    );
}